import React from 'react';

const LoadingPage = () => {
  const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    @keyframes fadeInUp {
      0% {
        opacity: 0;
        transform: translateY(20px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div 
        className="loading-overlay"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#0a0a0a',
          //backgroundColor: "#BE0703",
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
        }}
      >
        <div 
          className="loading-spinner"
          style={{
            position: 'absolute',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            border: '5px solid transparent',
            borderTopColor: 'black',
            borderBottomColor: '#ffffff',
            animation: 'spin 1.5s linear infinite'
          }}
        >
          <div
            style={{
              content: "''",
              position: 'absolute',
              top: '10px',
              left: '10px',
              right: '10px',
              bottom: '10px',
              borderRadius: '50%',
              border: '5px solid transparent',
              borderTopColor: '#ffffff',
              borderBottomColor: '#BE0703',
              animation: 'spin 1.2s linear infinite reverse'
            }}
          />
        </div>
        
        <div 
          className="loading-logo"
          style={{
            fontSize: '5rem',
            fontWeight: 700,
            color: '#ffffff',
            opacity: 0,
            transform: 'translateY(20px)',
            animation: 'fadeInUp 1s ease forwards',
            textShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
            zIndex: 1
          }}
        >
          JOTLU
        </div>
      </div>
    </>
  );
};

export default LoadingPage;